<template>
    <!-- TEMPLATENAME: byosSucess.isml -->
    <div v-if="currentStage === 'success'" class="byos-success-container text-center container-fluid">
        <div class="row">
            <div class="success-msg-container">
                <div class="mx-auto mx-md-0 text-center text-md-left success-msg-last">
                    <div role="alert" aria-live="assertive">
                        <h3 class="success-msg-heading h1" v-html="$t('success.message')"></h3>
                        <p class="success-msg-description subheader2" v-html="$t('success.messsage.description')"></p>
                    </div>
                    <a class="btn btn-block build-new-gift btn-outline-primary"
                        :href="`${actionURLs['BYOS-Landing']}?pgId=category`" v-html="$t('build.anothergift')"></a>
                </div>
            </div>
            <div class="image-container">
                <div v-if="$t('content.asset.byos-success-image')" v-html="$t('content.asset.byos-success-image')"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { mapState } from "@/store/helper/vuex";
import { mapGetters } from "@/store/helper/vuex";
const { currentStage } = mapGetters();

const { actionURLs } = mapState();
</script>